'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setResultType = exports.loadResultType = exports.loadTime = exports.loadDate = exports.loadActivity = exports.loadVerticals = exports.SET_RESULT_TYPE = exports.LOAD_RESULT_TYPE = exports.LOAD_TIME = exports.LOAD_DATE = exports.LOAD_ACTIVITY = exports.LOAD_VERTICALS = exports.ACTIVITY_OPTIONS = exports.TIME_OPTIONS = exports.TIME_DEFAULT = exports.VERTICALS_OPTIONS = exports.VERTICALS = exports.RESULT_TYPE_DEFAULT = exports.VERTICAL_DEFAULT = exports.selectSearchFilterWriteActions = exports.makeWriteFilterSetSelector = exports.searchFilterActions = undefined;

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

exports.doLoadVerticals = doLoadVerticals;
exports.doLoadActivity = doLoadActivity;
exports.doLoadDate = doLoadDate;
exports.doLoadTime = doLoadTime;
exports.doLoadResultType = doLoadResultType;
exports.doSetResultType = doSetResultType;
exports.watchFilters = watchFilters;

var _effects = require('redux-saga/effects');

var _filtersets = require('redux/modules/filtersets');

var _selectors = require('redux/saga/selectors');

var _filterSets = require('constants/filter-sets');

var _Search = require('../Search.helpers');

var _Search2 = require('../Search.constants');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _marked = /*#__PURE__*/_regenerator2.default.mark(doLoadVerticals),
    _marked2 = /*#__PURE__*/_regenerator2.default.mark(doLoadActivity),
    _marked3 = /*#__PURE__*/_regenerator2.default.mark(doLoadDate),
    _marked4 = /*#__PURE__*/_regenerator2.default.mark(doLoadTime),
    _marked5 = /*#__PURE__*/_regenerator2.default.mark(doLoadResultType),
    _marked6 = /*#__PURE__*/_regenerator2.default.mark(doSetResultType),
    _marked7 = /*#__PURE__*/_regenerator2.default.mark(watchFilters);

var searchFilterActions = exports.searchFilterActions = (0, _filtersets.actionsForFilterSet)(_filterSets.SEARCH);

var addFilter = searchFilterActions.addFilter,
    setFilterValue = searchFilterActions.setFilterValue;
var ACTIVITY = _Search2.FILTER_NAMES.ACTIVITY,
    DATE = _Search2.FILTER_NAMES.DATE,
    RESULT_TYPE = _Search2.FILTER_NAMES.RESULT_TYPE,
    TIME = _Search2.FILTER_NAMES.TIME,
    VERTICAL = _Search2.FILTER_NAMES.VERTICAL;
var SCHEDULE = _Search2.RESULT_TYPES.SCHEDULE;
var makeWriteFilterSetSelector = exports.makeWriteFilterSetSelector = function makeWriteFilterSetSelector(filterSet) {
  return function (action) {
    return _filtersets.FILTER_WRITE_ACTIONS.includes(action.type) && action.data && action.data.filterSetId && action.data.filterSetId === filterSet && action.data.filter !== VERTICAL;
  };
};

var selectSearchFilterWriteActions = exports.selectSearchFilterWriteActions = makeWriteFilterSetSelector(_filterSets.SEARCH);

var VERTICAL_DEFAULT = exports.VERTICAL_DEFAULT = 'fitness'; // eslint-disable-line no-unused-vars

var RESULT_TYPE_DEFAULT = exports.RESULT_TYPE_DEFAULT = SCHEDULE; // eslint-disable-line no-unused-vars

var VERTICALS = exports.VERTICALS = {
  fitness: 'fitness',
  wellness: 'wellness',
  gym: 'gym'
};

var VERTICALS_OPTIONS = exports.VERTICALS_OPTIONS = [{ id: VERTICALS.fitness, name: 'Group Fitness', description: 'Yoga, boxing, pilates, etc' }, { id: VERTICALS.wellness, name: 'Wellness', description: 'Massages, meditation, etc.' }, { id: VERTICALS.gym, name: 'Gym Time', description: 'Book flexible sessions at the gym' }];

var TIME_DEFAULT = exports.TIME_DEFAULT = '04:30-23:00';
var TIME_OPTIONS = exports.TIME_OPTIONS = [{ id: '04:30-07:00', name: 'Early Morning', description: 'Before 7 am' }, { id: '07:00-11:00', name: 'Mid Morning', description: '7 am - 11 am' }, { id: '11:00-14:00', name: 'Lunchtime', description: '11 am - 2 pm' }, { id: '14:00-17:00', name: 'Afternoon', description: '2 pm - 5 pm' }, { id: '17:00-20:00', name: 'Evening', description: '5 pm - 8pm' }, { id: '20:00-23:00', name: 'Late evening', description: 'After 8 pm' }];

var ACTIVITY_OPTIONS = exports.ACTIVITY_OPTIONS = {
  fitness: [{ id: 'activity-1', name: 'Yoga' }, { id: 'activity-553', name: 'Barre' }, { id: 'activity-95', name: 'Strength training' }, { id: 'activity-23', name: 'Martial arts' }, { id: 'activity-467', name: 'Rowing' }, { id: 'activity-589', name: 'Running' }, { id: '869', name: 'Prenatal' }, { id: 'activity-72', name: 'Cycling' }, { id: 'activity-90', name: 'Pilates' }, { id: 'activity-100', name: 'Dance' }, { id: 'activity-587', name: 'Boxing' }, { id: 'activity-591', name: 'Outdoors' }, { id: 'activity-590', name: 'Sports' }],
  wellness: [{ id: '1145', name: 'Massage' }, { id: '1147', name: 'Facial' }, { id: '1149', name: 'Cryotherapy' }, { id: '1151', name: 'Sports recovery' }, { id: '1153', name: 'Sauna' }, { id: '1155', name: 'Meditation' }, { id: '1157', name: 'Acupuncture' }, { id: '1159', name: 'Cupping' }, { id: '1161', name: 'Beauty' }]
};

var LOAD_VERTICALS = exports.LOAD_VERTICALS = 'LOAD_VERTICALS';
var LOAD_ACTIVITY = exports.LOAD_ACTIVITY = 'LOAD_ACTIVITY';
var LOAD_DATE = exports.LOAD_DATE = 'LOAD_DATE';
var LOAD_TIME = exports.LOAD_TIME = 'LOAD_TIME';
var LOAD_RESULT_TYPE = exports.LOAD_RESULT_TYPE = 'LOAD_RESULT_TYPE';
var SET_RESULT_TYPE = exports.SET_RESULT_TYPE = 'SET_RESULT_TYPE';

var loadVerticals = exports.loadVerticals = function loadVerticals() {
  return { type: LOAD_VERTICALS };
};
var loadActivity = exports.loadActivity = function loadActivity() {
  return { type: LOAD_ACTIVITY };
};
var loadDate = exports.loadDate = function loadDate() {
  return { type: LOAD_DATE };
};
var loadTime = exports.loadTime = function loadTime() {
  return { type: LOAD_TIME };
};
var loadResultType = exports.loadResultType = function loadResultType() {
  return { type: LOAD_RESULT_TYPE };
};
var setResultType = exports.setResultType = function setResultType() {
  return { type: SET_RESULT_TYPE };
};

function doLoadVerticals() {
  var _ref, vertical;

  return _regenerator2.default.wrap(function doLoadVerticals$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _context.next = 2;
          return (0, _effects.select)(_Search.selectFiltersFromHash);

        case 2:
          _ref = _context.sent;
          vertical = _ref.vertical;
          _context.next = 6;
          return (0, _effects.put)(addFilter(VERTICAL, VERTICALS_OPTIONS, undefined, { exclusive: true, value: vertical || VERTICAL_DEFAULT }));

        case 6:
        case 'end':
          return _context.stop();
      }
    }
  }, _marked, this);
}

function doLoadActivity() {
  var _ref2, verticals, vertical, _ref3, tags, selected;

  return _regenerator2.default.wrap(function doLoadActivity$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          _context2.next = 2;
          return (0, _effects.select)(_selectors.filterSetFilters, _filterSets.SEARCH);

        case 2:
          _ref2 = _context2.sent;
          verticals = _ref2.verticals;
          vertical = verticals && verticals.value;
          _context2.next = 7;
          return (0, _effects.select)(_Search.selectFiltersFromHash);

        case 7:
          _ref3 = _context2.sent;
          tags = _ref3.tag;


          // If 2 or more tags, we initialize the activity filter with those tags.
          // See SearchBox.saga.js for handling when 1 tag is selected.
          selected = tags && tags.length > 1 && tags.reduce(function (acc, tag) {
            return (0, _extends4.default)({}, acc, (0, _defineProperty3.default)({}, tag, true));
          }, {});
          _context2.next = 12;
          return (0, _effects.put)(addFilter(ACTIVITY, ACTIVITY_OPTIONS[vertical || VERTICAL_DEFAULT], undefined, { selected: selected }));

        case 12:
        case 'end':
          return _context2.stop();
      }
    }
  }, _marked2, this);
}

function doLoadDate() {
  var _ref4, dateFilter, _ref5, date;

  return _regenerator2.default.wrap(function doLoadDate$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          _context3.next = 2;
          return (0, _effects.select)(_selectors.filterSetFilters, _filterSets.SEARCH);

        case 2:
          _ref4 = _context3.sent;
          dateFilter = _ref4.date;

          if (!(dateFilter && dateFilter.value)) {
            _context3.next = 6;
            break;
          }

          return _context3.abrupt('return');

        case 6:
          _context3.next = 8;
          return (0, _effects.select)(_Search.selectFiltersFromHash);

        case 8:
          _ref5 = _context3.sent;
          date = _ref5.date;
          _context3.next = 12;
          return (0, _effects.put)(addFilter(DATE, [], undefined, { valueFilter: true, value: date }));

        case 12:
        case 'end':
          return _context3.stop();
      }
    }
  }, _marked3, this);
}

function doLoadTime() {
  var _ref6, time, _ref7, ft, tt;

  return _regenerator2.default.wrap(function doLoadTime$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          _context4.next = 2;
          return (0, _effects.select)(_selectors.filterSetFilters, _filterSets.SEARCH);

        case 2:
          _ref6 = _context4.sent;
          time = _ref6.time;

          if (!(time && time.value)) {
            _context4.next = 6;
            break;
          }

          return _context4.abrupt('return');

        case 6:
          _context4.next = 8;
          return (0, _effects.select)(_Search.selectFiltersFromHash);

        case 8:
          _ref7 = _context4.sent;
          ft = _ref7.ft;
          tt = _ref7.tt;
          _context4.next = 13;
          return (0, _effects.put)(addFilter(TIME, TIME_OPTIONS, undefined, { valueFilter: true, value: (ft || tt) && ft + '-' + tt }));

        case 13:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

function doLoadResultType() {
  return _regenerator2.default.wrap(function doLoadResultType$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return (0, _effects.put)(addFilter(RESULT_TYPE, VERTICALS_OPTIONS, undefined, { exclusive: true, value: RESULT_TYPE_DEFAULT }));

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}

function doSetResultType() {
  var _ref8, resultType;

  return _regenerator2.default.wrap(function doSetResultType$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return (0, _effects.select)(_Search.selectFiltersFromHash);

        case 2:
          _ref8 = _context6.sent;
          resultType = _ref8.result_type;
          _context6.next = 6;
          return (0, _effects.put)(setFilterValue(_Search2.FILTER_NAMES.RESULT_TYPE, resultType));

        case 6:
        case 'end':
          return _context6.stop();
      }
    }
  }, _marked6, this);
}

function watchFilters() {
  return _regenerator2.default.wrap(function watchFilters$(_context7) {
    while (1) {
      switch (_context7.prev = _context7.next) {
        case 0:
          _context7.next = 2;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_VERTICALS, doLoadVerticals);

        case 2:
          _context7.next = 4;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_ACTIVITY, doLoadActivity);

        case 4:
          _context7.next = 6;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_DATE, doLoadDate);

        case 6:
          _context7.next = 8;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_TIME, doLoadTime);

        case 8:
          _context7.next = 10;
          return (0, _effects.fork)(_effects.takeLatest, LOAD_RESULT_TYPE, doLoadResultType);

        case 10:
        case 'end':
          return _context7.stop();
      }
    }
  }, _marked7, this);
}